const msToMinutes = ms => Math.ceil(ms / 60000);

export default msToMinutes;
